import React from "react";
import { wa } from "../../mock";
import banner from "./corporateBanner.json";
import "./corporate-buyback-banner.css";

export const CorporateBuybackBanner = () => (
  <section id="corporate-buyback-banner" className="corporate-buyback-banner"
    data-testid="corporate-buyback-banner" aria-label="Bulk IT Asset Buyback and Startup Liquidation Solutions">
    <img src={banner.image} data-testid="corporate-banner-image"
      width={banner.width} height={banner.height} alt={banner.alt} loading="lazy" decoding="async" />
    {banner.hotspots.map((hotspot) => (
      <a key={hotspot.id} className="corporate-banner-hotspot"
        data-testid={`corporate-banner-${hotspot.id}-hotspot`}
        href={hotspot.kind === "whatsapp" ? wa(banner.whatsappMessage) : "#enquiry-form"}
        aria-label={hotspot.label} title={hotspot.label}
        target={hotspot.kind === "whatsapp" ? "_blank" : undefined}
        rel={hotspot.kind === "whatsapp" ? "noopener noreferrer" : undefined}
        style={{ left: `${hotspot.left}%`, top: `${hotspot.top}%`, width: `${hotspot.width}%`, height: `${hotspot.height}%` }} />
    ))}
  </section>
);